const apiDomain = process.env.API_DOMAIN;

export const API_DOMAIN = apiDomain;
